import { FC } from 'react';
import { Tab as MuiTab, TabProps } from '@mui/material';
import { clsx } from '../../utils';
import { tabStyles } from './tab.styles';

export const Tab: FC<TabProps> = ({ sx, ...props }) => <MuiTab {...props} sx={clsx(tabStyles, sx)} />;
